import { Inject, Injectable } from '@angular/core';
import { CoreInjectorTokens, Environment, EnvironmentType } from '@fleet-beat/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentCheckService {
  get qaDev(): boolean {
    return this.check([EnvironmentType.DEV, EnvironmentType.QA]);
  }

  get stageProdDemo(): boolean {
    return this.check([EnvironmentType.STAGE, EnvironmentType.DEMO, EnvironmentType.PROD]);
  }

  constructor(@Inject(CoreInjectorTokens.Environment) private environment: Environment) {}

  check(environments: EnvironmentType[]): boolean {
    if (!environments) {
      return true;
    }

    return environments.includes(this.environment.type);
  }
}
